import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  list: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  save: ReducersTooling.initialStates.getFetchTypeInitialState(),
  delete: ReducersTooling.initialStates.getFetchTypeInitialStateDelete(),
  dimensionInstancesList: ReducersTooling.initialStates.getFetchTypeInitialState(),
  importDimensionInstances: ReducersTooling.initialStates.getFetchTypeInitialState(),
  downloadImportDimensionInstances: ReducersTooling.initialStates.getFetchTypeInitialState(),
  tagsList: ReducersTooling.initialStates.getFetchTypeInitialState(),
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/dimensionAdmin/initialState.js